import { useState } from 'preact/hooks';
import { api } from '../api';
import { countryOptions } from '../countries';
import type { T } from '../i18n';
import { deviceCountry } from '../region';
import { errorText, set, toast } from '../state';
import type { AppState } from '../state';
import { LangToggle, Toast } from './Shell';

/**
 * Asked once, before anything else: which country you write from. Delivery
 * times are worked out from it, so the app waits for an answer. The country
 * the device is in is suggested.
 */
export function Welcome({ s, t }: { s: AppState; t: T }) {
  const user = s.user!;
  const [country, setCountry] = useState(deviceCountry());
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      const { user: updated } = await api.updateMe({ handle: user.handle, country, lang: s.lang, countryChosen: true });
      set({ user: updated });
    } catch (err) {
      setBusy(false);
      toast(errorText(err, t('genericError')), 'error');
    }
  };

  return (
    <div class="welcome">
      <div class="welcome-intro">
        <img class="welcome-logo" src="/assets/logo2.png" alt="Qué fue, pana?" />
        <div class="kicker">{t('welcomeHello', { who: user.handle })}</div>
        <h1 class="welcome-title">{t('welcomeTitle')}</h1>
        <p class="welcome-body">{t('welcomeBody')}</p>
      </div>
      <form
        class="welcome-form"
        onSubmit={(e) => {
          e.preventDefault();
          void start();
        }}
      >
        <label>
          <div class="kicker">{t('countryLabel')}</div>
          <select class="field" value={country} onChange={(e) => setCountry(e.currentTarget.value)}>
            {countryOptions(s.lang).map((o) => (
              <option key={o.key} value={o.key}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
        <button type="submit" class="btn-ink welcome-go" disabled={busy}>
          {t('welcomeGo')}
        </button>
        <div class="welcome-lang">
          <LangToggle s={s} />
        </div>
      </form>
      <Toast s={s} />
    </div>
  );
}
